import type { PatchAssetStateRequest } from './assetPatchState';
import apiRequest from './apiRequest';

export default async function patchSceneByID(
  apiKey: string,
  sceneID: string,
  body: PatchAssetStateRequest,
) {
  return apiRequest<Record<string, never>>(
    'external-mogen',
    `/scenes/${encodeURIComponent(sceneID)}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(body),
    },
  );
}
